import axios from './axios';
import { Line, LineCreate, LineUpdate, LineWithCount } from '../types/line';

const BASE_URL = '/lines';

export const lineApi = {
  getLines: async (params?: { 
    skip?: number; 
    limit?: number; 
    project_id?: number;
    status?: boolean;
  }) => {
    const response = await axios.get<Line[]>(BASE_URL, { params });
    return response.data;
  },

  getLine: async (id: number) => {
    const response = await axios.get<LineWithCount>(`${BASE_URL}/${id}`);
    return response.data;
  },

  createLine: async (data: LineCreate) => {
    const response = await axios.post<Line>(BASE_URL, data);
    return response.data;
  },

  updateLine: async (id: number, data: LineUpdate) => {
    const response = await axios.put<Line>(`${BASE_URL}/${id}`, data);
    return response.data;
  },

  deleteLine: async (id: number) => {
    await axios.delete(`${BASE_URL}/${id}`);
  },
};
